// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"76534c2f","180":"f47bcfa1","360":"394b550d","778":"76534c2f"}[chunkId] + ".chunk.css";
};